import axios from 'axios'


class Token {

	checkIfValid() {
		let token = this.get()
		if(token) {
			axios.defaults.headers.common['Authorization'] = token
		}
		return axios.get('api/me/')
	}

	get() {
		return localStorage.getItem('token')
	}

	remove() {
		localStorage.removeItem('token')
	}

	set(acces_token) {
		const token = `Token ${acces_token}`
		axios.defaults.headers.common['Authorization'] = token
		localStorage.setItem('token', token)
	}
}

export default new Token()


// WEBPACK FOOTER //
// ./src/helpers/token.js